import _ from "lodash";
import moment from "moment";
import numeral from "numeral";
import {
  APP_LANGUAGE,
  CATEGORY_IDS_SORT_BY_PRICE,
  ID_CATEGORY_MATTRESS,
  ID_CATEGORY_SOFA_ROSSY_LUXE_PROD,
  ID_CATEGORY_SOFA_ROSSY_LUXE_TEST,
  LIST_IDS_CATEGORY_BED_FOLDING,
  LIST_IDS_CATEGORY_BED_SHEET,
  LIST_IDS_CATEGORY_MATTRESS,
  LIST_IDS_SPECIAL_DELUXE_PILLOW_TOP,
  PRODUCT_PROPS_SOFA_ROSSY_LUXE_COVER,
  PRODUCT_SALON_PROPS,
  PROPERTY_TYPE,
  PROP_BED_PREMIUM,
  PROP_BED_SIMILI,
  PROP_SOFA_ROSSY_LUXE_PREMIUM,
  PROP_SOFA_ROSSY_LUXE_SIMILI,
} from "../common/constant";
import i18n from "../i18n";
import { rootUrl } from "../common";

export const validatePhoneNumber = (
  value: string,
  callback: Function,
  t: any
) => {
  const reg = /(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/;
  if (value && !reg.test(value)) {
    callback(t("phone_number_valid"));
  } else {
    callback();
  }
};

export const markPhoneNumber = (
  phone: string = "",
  substitute: string,
  start: number = 0,
  end: number = 6
) => {
  return phone.substring(0, start) + substitute + phone.substring(end);
};

export const localizeRouteKey = (path: string, params: string[] = []) => {
  if (params && params.length != 0) {
    let origin_path = `/${i18n.language}` + i18n.t(path);
    if (!params || params.length == 0) {
      return origin_path;
    }
    let _path = "";
    const sub_paths = origin_path.split("/");
    let index = 0;
    for (let i = 0; i < sub_paths.length; i++) {
      let p = sub_paths[i];
      if (!p) {
        continue;
      }
      if (p[0] == ":" && index < params.length) {
        p = params[index];
        index++;
      }
      _path += "/" + p;
    }
    return _path;
  } else {
    return `/${i18n.language}` + i18n.t(path);
  }
};

export const getMatchingRoute = (pathname: string, language: string) => {
  //   const route = pathname.split(i18n.language)[1];
  const route = pathname.slice(3);

  const datasCurrentLanguage =
    i18n.getDataByLanguage(i18n.language)?.translation || {};

  const routeKey =
    Object.keys(datasCurrentLanguage).find(
      (key: string) => datasCurrentLanguage[key] === route
    ) || "";

  if (!routeKey) return pathname;

  const datasChangedLanguage =
    i18n.getDataByLanguage(language)?.translation || {};

  return `/${language}` + datasChangedLanguage[routeKey];
};

export const visibleContactAndFooter = () => {
  const contactWrap: any = document.querySelector(".contact-us-wrapper");
  const footertWrap: any = document.querySelector(".footer-container");

  if (contactWrap && footertWrap) {
    const isExistClass =
      contactWrap.classList.contains("hide-element") &&
      footertWrap.classList.contains("hide-element");
    if (isExistClass) {
      contactWrap.classList.remove("hide-element");
      footertWrap.classList.remove("hide-element");
    }
  }
};

export const getImageOrVideoPath = (imgs: any) => {
  return (
    (imgs &&
      imgs.length &&
      imgs[0].galaries.length &&
      imgs[0].galaries[0].path) ||
    ""
  );
};

export const getImageOrVideoPaths = (data: any) => {
  return data && data.length && data[0].galaries.length
    ? data[0].galaries.map((item: any) => item.path)
    : [];
};

const getImagesByDeviceFilterOrDefault = (data: any, device: string) => {
  let result = data.filter((v: any) => {
    if (v.galaries && v.galaries.length) {
      if (v.device_type?.code === device || !device) {
        return v;
      }
    }
  })[0];

  if (!result) {
    result = data.filter(
      (d: any) => d.galaries && d.galaries.length && !d.device_type
    )[0];
  }

  return result;
};

export const getImageFromSection = (
  data: any,
  field: string,
  device: any,
  language: string = "default"
) => {
  let result: any;
  if (data.localized_resources && data.localized_resources.length) {
    data.localized_resources.forEach((item: any) => {
      if (
        item.lang === language &&
        item.field === field &&
        item.values &&
        item.values.length
      ) {
        result = getImagesByDeviceFilterOrDefault(item.values, device);
      }
    });
  }

  if (!result) {
    if (data[field] && data[field].length) {
      result = getImagesByDeviceFilterOrDefault(data[field], device);
    }
  }

  return result;
};

export const getSectionCategoryDescriptionBySlug = (slug: string) => {
  let result = [];

  switch (slug) {
    case "nem":
      result.push("606fb15a58be6ca7dab287e7");
      break;
    case "goi":
      result.push("6077c165dab9b92c758fbefc");
      break;
    case "ga":
      result.push("606fbb4b58be6ca7dab2908a");
      break;
    case "giuong":
      result.push("60ab6c05d822a269866d8d05");
      break;
    case "sofa":
      result.push("60ac6724b0d69462ae339da9");
      break;
    default:
      break;
  }

  return result;
};

export const getSlugByLanguage = (entity: any, lang: string) =>
  lang === APP_LANGUAGE.Vietnamese
    ? entity.slug
    : entity.slug_en || entity.slug;

export const getNumberFromFeature = (feature: string) => {
  const rs = feature.replace(/[^0-9]/g, "");

  return rs;
};

export const checkNewProductFeature = (pf: any) => {
  if (!pf || !pf.product_props || !pf.product_props.length) {
    return false;
  }
  return true;
};

export const checkNewProductFeatureHaveCover = (pf: any) => {
  if (
    !pf ||
    !pf.product_props ||
    !pf.product_props.find((f: any) => f.code == PROPERTY_TYPE.cover)
  ) {
    return false;
  }
  return true;
};

export const checkNewProductFeatureByCoverType = (
  pf: any,
  coverType: string
) => {
  if (
    !pf ||
    !pf.product_props ||
    !pf.product_props.find((f: any) => {
      const temp = f?.values?.find((cover: any) => cover?.value == coverType);

      return (
        f.code == PROPERTY_TYPE.cover &&
        temp &&
        pf.value.includes(temp.pf_prefix)
      );
    })
  ) {
    return false;
  }
  return true;
};

export const getMinKdeProIdFromFeatures = (features: any) => {
  let rs = -1;

  if (features) {
    if (features.length) {
      rs = features.reduce((min: any, currentFeature: any) => {
        if (min > currentFeature.kde_pro_id) {
          min = currentFeature.kde_pro_id;
        }

        return min;
      }, features[0].kde_pro_id);
    } else {
      if (features.kde_pro_id) {
        rs = features.kde_pro_id;
      }
    }
  }

  return rs;
};

export const checkInCompareList = (prod: any, list: any[]) => {
  let rs = false;

  const _list = list.filter((item: any) => {
    let check = false;

    if (
      prod.feature?.value === item.properties?.feature?.value &&
      prod.pattern?.value === item.properties?.pattern?.value &&
      prod.desk?.value === item.properties?.desk?.value &&
      prod.foam?.value === item.properties?.foam?.value &&
      prod.cover?.value === item.properties?.cover?.value
    ) {
      check = true;
    }

    return check;
  });

  if (Array.isArray(_list) && _list.length) {
    rs = true;
  }

  return rs;
};

export const checkProductHaveType = (features: any) => {
  let rs = false;
  if (features && features.length) {
    let kdeProId = features[0].kde_pro_id;

    features.forEach((feature: any) => {
      if (rs === true) return;

      if (feature.kde_pro_id && feature.kde_pro_id !== kdeProId) {
        rs = true;
      }
    });
  }

  return rs;
};

export const checkRossyLuxe = (category_id: string) => {
  if (
    category_id == ID_CATEGORY_SOFA_ROSSY_LUXE_TEST ||
    category_id == ID_CATEGORY_SOFA_ROSSY_LUXE_PROD
    // product_id == ID_PRODUCT_SOFA_ROSSY_LUXE_TEST ||
    // product_id == ID_PRODUCT_SOFA_ROSSY_LUXE_PROD
  ) {
    return true;
  }

  return false;
};

export const checkProductHaveCover = (
  feature: any,
  isRossyLuxe: boolean = false,
  isNewProductFeature: boolean = false
) => {
  if (isNewProductFeature) return true;

  let rs = false;
  if (feature && feature.length) {
    let checkPremium, checkVinyl;

    if (isRossyLuxe) {
      checkPremium = feature.endsWith(PROP_SOFA_ROSSY_LUXE_PREMIUM);
      checkVinyl = feature.endsWith(PROP_SOFA_ROSSY_LUXE_SIMILI);
    } else {
      checkPremium = feature.endsWith(PROP_BED_PREMIUM);
      checkVinyl = feature.endsWith(PROP_BED_SIMILI);
    }

    if (checkPremium || checkVinyl) {
      rs = true;
    }
  }

  return rs;
};

export const checkTypeValid = (
  features: any[],
  type: string,
  checkDesk: boolean,
  minKdeProId: number
) => {
  const filterFeatureResponse = features.filter(
    (f: any) =>
      (!checkNewProductFeatureHaveCover(features[0])
        ? f.value.endsWith(type)
        : checkNewProductFeatureByCoverType(f, type)) &&
      (checkDesk ? f.kde_pro_id > minKdeProId : f.kde_pro_id === minKdeProId)
  );

  if (filterFeatureResponse && filterFeatureResponse.length) return true;

  return false;
};

export const getKindOfBed = (value: string = "", product_props = []) => {
  if (product_props.length) {
    const prop: any = product_props.find(
      (p: any) => p.code === PROPERTY_TYPE.cover
    );

    if (prop && prop.values && prop.values.length) {
      const _cover: string =
        prop.values.find((p: any) => value.includes(p.pf_prefix)).value || "";

      return PRODUCT_PROPS_SOFA_ROSSY_LUXE_COVER.find(
        (cover: any) => cover.value === _cover
      )?.label;
    }
  } else if (value && value.length) {
    const lastCharacter = value[value.length - 1];

    if (lastCharacter !== "0") {
      return PRODUCT_SALON_PROPS[lastCharacter];
    }
  }

  return "";
};

export const checkSpecialMattress = (
  price: string = "",
  pricePromotion: string = ""
) => {
  const _price = numeral(price.replaceAll(".", ","));
  const _pricePromotion = numeral(pricePromotion.replaceAll(".", ","));

  if (
    _price.value() != null &&
    _pricePromotion.value() != null &&
    _price.value() === _pricePromotion.value()
  ) {
    return true;
  }

  return false;
};

export const getDiscountName = (
  price: string = "",
  pricePromotion: string = "",
  discount: string = ""
) => {
  if (!checkSpecialMattress(price, pricePromotion) && discount) {
    return `-${discount}`;
  }

  return i18n.t("new_offer_price");
};

//Hard code tạm thời
export const checkGrandOpeningPromotion = (
  isCheckGrandOpeningPromotion: boolean = false,
  price: string = "",
  idCategory: string = ""
) => {
  if (LIST_IDS_CATEGORY_BED_SHEET.includes(idCategory)) {
    return true;
  }

  if (!price || !isCheckGrandOpeningPromotion) {
    return false;
  }

  const _pricePromotion = numeral(price.replaceAll(".", ","));

  if (
    idCategory !== ID_CATEGORY_MATTRESS &&
    !LIST_IDS_CATEGORY_MATTRESS.includes(idCategory) &&
    !LIST_IDS_CATEGORY_BED_FOLDING.includes(idCategory)
  ) {
    return false;
  }

  if (isCheckGrandOpeningPromotion && _pricePromotion.value() > 15000000) {
    return true;
  }

  return false;
};

//Hard code tạm thời
export const checkTagPromotionForSpecialMattress = (productId: string = "") =>
  LIST_IDS_SPECIAL_DELUXE_PILLOW_TOP.includes(productId);

export const getPriceDisplay = (
  price: string = "",
  pricePromotion: string = ""
) => {
  let rs = " ";

  if (!checkSpecialMattress(price, pricePromotion)) {
    rs = `(${price} VND)`;
  }

  return rs;
};

export const checkDarkBackgroundColor = (color: string) => {
  if (
    color !== "#fff" &&
    color !== "#ffffff" &&
    color !== "rgb(245, 245, 245)" &&
    color !== "rgb(247, 248, 249)" &&
    color !== "rgb(249, 249, 250)"
  ) {
    return true;
  }

  return false;
};

export const getBanners = (data: any) => {
  return data.map((v: string, i: any) => ({
    imageUrl: v,
    id: i,
  }));
};

export const checkProductWish = (item: any, wishesList?: any[]) => {
  const rs = _.findIndex(wishesList, {
    feature_code: item.product_feature_code,
    kde_pro_id: item.kde_pro_id,
    kde_pro_spec_id: item.kde_pro_spec_id,
  });

  if (rs !== -1) return true;
  return false;
};

export const getProductPropertyForSection = (product: any) => {
  let result = null;

  if (
    product.product_specs &&
    product.product_specs.length &&
    product.product_specs[0].img_details.length
  ) {
    const spec = product.product_specs[0];

    result = {
      [PROPERTY_TYPE.image]: {
        code: PROPERTY_TYPE.image,
        image:
          spec.img_details && spec.img_details.length
            ? spec.img_details[0].path
            : null,
        is_use: false,
        label: spec.name,
        position: 3,
        title: "Hoa văn",
        value: spec.kde_pro_spec_id + "|" + spec.kde_pro_id,
      },
    };
  }

  return result;
};

export const getProductPropertyForProductWish = (product: any) => {
  let result = null;

  if (product.kde_pro_id && product.kde_pro_spec_id) {
    result = {
      [PROPERTY_TYPE.image]: {
        code: PROPERTY_TYPE.image,
        image: product.spec_img ? product.spec_img : product.img,
        is_use: false,
        label: product.spec_name,
        position: 3,
        title: "Hoa văn",
        value: product.kde_pro_spec_id + "|" + product.kde_pro_id,
      },
    };
  }

  return result;
};

export const addSpace = (text: string) => {
  let rs: string = text;
  const index = text.indexOf("cm");

  if (index !== -1) {
    if (text[index - 1] !== " ") {
      rs = `${text.slice(0, index)} ${text.slice(index, text.length)}`;
    }
  }

  return rs;
};

export const excludeProperty = (excludeProp = "", value: any) => {
  let result: any = false;
  let _value = value || -1;

  let _excludeProp = excludeProp;
  if (_excludeProp) {
    if (_excludeProp.split("|") !== undefined) {
      result =
        _excludeProp.split("|").find((p) => p === _value.toString()) || false;
    }
  }

  return result;
};

export const getValueFieldByLanguage = (
  data: any,
  field: string,
  language: string = "default"
) => {
  let result;
  if (data.localized_resources && data.localized_resources.length) {
    result = data.localized_resources.filter(
      (item: any) =>
        item.lang === language && item.field === field && item.value
    )[0]?.value;
  }
  if (!result && data[field]) {
    result = data[field];
  }
  return result;
};

const STRINGS: any = {
  nodiff: "",
  year: "năm",
  years: "năm",
  month: "tháng",
  months: "tháng",
  day: "ngày",
  days: "ngày",
  hour: "hour",
  hours: "hours",
  minute: "minute",
  minutes: "minutes",
  second: "second",
  seconds: "seconds",
  delimiter: " ",
};

const pluralize = (num: any, word: any) => {
  return num + " " + STRINGS[word + (num === 1 ? "" : "s")];
};

const buildStringFromValues = (
  yDiff: any,
  mDiff: any,
  dDiff: any,
  hourDiff: any,
  minDiff: any,
  secDiff: any
) => {
  let result = [];

  if (yDiff) {
    result.push(pluralize(yDiff, "year"));
  }
  if (mDiff) {
    result.push(pluralize(mDiff, "month"));
  }
  if (dDiff) {
    result.push(pluralize(dDiff, "day"));
  }
  if (hourDiff) {
    result.push(pluralize(hourDiff, "hour"));
  }
  if (minDiff) {
    result.push(pluralize(minDiff, "minute"));
  }
  if (secDiff) {
    result.push(pluralize(secDiff, "second"));
  }

  return result.join(STRINGS.delimiter);
};

const buildValueObject = (
  yDiff: any,
  mDiff: any,
  dDiff: any,
  hourDiff: any,
  minDiff: any,
  secDiff: any,
  firstDateWasLater: any
) => {
  return {
    years: yDiff,
    months: mDiff,
    days: dDiff,
    hours: hourDiff,
    minutes: minDiff,
    seconds: secDiff,
    firstDateWasLater: firstDateWasLater,
  };
};

export const preciseDiff = (d1: any, d2: any, returnValueObject = false) => {
  let m1 = moment(d1);
  let m2 = moment(d2);
  let firstDateWasLater;

  m1.add(m2.utcOffset() - m1.utcOffset(), "minutes"); // shift timezone of m1 to m2

  if (m1.isSame(m2)) {
    if (returnValueObject) {
      return buildValueObject(0, 0, 0, 0, 0, 0, false);
    } else {
      return STRINGS.nodiff;
    }
  }
  if (m1.isAfter(m2)) {
    let tmp = m1;
    m1 = m2;
    m2 = tmp;
    firstDateWasLater = true;
  } else {
    firstDateWasLater = false;
  }

  let yDiff = m2.year() - m1.year();
  let mDiff = m2.month() - m1.month();
  let dDiff = m2.date() - m1.date();
  let hourDiff = m2.hour() - m1.hour();
  let minDiff = m2.minute() - m1.minute();
  let secDiff = m2.second() - m1.second();

  if (secDiff < 0) {
    secDiff = 60 + secDiff;
    minDiff--;
  }
  if (minDiff < 0) {
    minDiff = 60 + minDiff;
    hourDiff--;
  }
  if (hourDiff < 0) {
    hourDiff = 24 + hourDiff;
    dDiff--;
  }
  if (dDiff < 0) {
    let daysInLastFullMonth = moment(
      m2.year() + "-" + (m2.month() + 1),
      "YYYY-MM"
    )
      .subtract(1, "M")
      .daysInMonth();
    if (daysInLastFullMonth < m1.date()) {
      // 31/01 -> 2/03
      dDiff = daysInLastFullMonth + dDiff + (m1.date() - daysInLastFullMonth);
    } else {
      dDiff = daysInLastFullMonth + dDiff;
    }
    mDiff--;
  }
  if (mDiff < 0) {
    mDiff = 12 + mDiff;
    yDiff--;
  }

  if (returnValueObject) {
    return buildValueObject(
      yDiff,
      mDiff,
      dDiff,
      hourDiff,
      minDiff,
      secDiff,
      firstDateWasLater
    );
  } else {
    return buildStringFromValues(
      yDiff,
      mDiff,
      dDiff,
      hourDiff,
      minDiff,
      secDiff
    );
  }
};

export const handleChangeIntersection = (
  inView: any,
  entry: any,
  className: string = ""
) => {
  if (inView) {
    entry.target.children[0].classList.add(className);
  }
};

export const checkGiftHaveReselect = (gifts: any = []) => {
  let rs = false;

  if (!gifts.length) {
    return rs;
  }

  gifts.forEach((item: any) => {
    if (
      item.name.toLowerCase().includes(" ga ") ||
      item.name.toLowerCase().includes(" drap ")
    ) {
      rs = true;
    }
    if (item.options && item.options.length) {
      rs = true;
    }
  });

  return rs;
};

export const checkQuerySyntax = (query: string = "") => {
  if (
    query.includes(i18n.t("detail_query")) ||
    query.includes("long=") ||
    query.includes("wide=") ||
    query.includes("thick=")
  ) {
    return true;
  }
  return false;
};

export const renderTotalAmount = (totalAmount: string = "") => {
  if (totalAmount && totalAmount != "0") {
    return totalAmount + " VND";
  }

  return "Liên hệ 1800953";
};

export const getMediaUrl = (mediaId: string, size: number = 500) => {
  return `${rootUrl}media/${mediaId}/${size}`;
};

const sortByPrice = (item: any) => {
  const _price = item.price || item[0].price;

  return numeral(_price.replaceAll(".", ",")).value();
};

const transformData = (list: any, chunkSize = 4) => {
  if (!Array.isArray(list)) return [];

  return list.flatMap((obj) => {
    const result = [];

    // Chỉ lấy product có specs hoac features
    if (
      obj.name &&
      ((Array.isArray(obj.specs) && obj.specs.length) ||
        (obj.data && obj.data.length))
    ) {
      result.push({ type: "title", data: obj.name });
    }

    if (Array.isArray(obj.specs) && obj.is_drap) {
      // Chia specs thành từng nhóm nhỏ
      for (let i = 0; i < obj.specs.length; i += chunkSize) {
        const chunk = obj.specs.slice(i, i + chunkSize);
        result.push({ type: "specs", data: chunk, product: obj });
      }
    } else if (Array.isArray(obj.data)) {
      const _data = CATEGORY_IDS_SORT_BY_PRICE.includes(obj.cat_id || "")
        ? _.sortBy(obj.data, [(item: any) => sortByPrice(item)])
        : obj.data;

      for (let i = 0; i < _data.length; i += chunkSize) {
        const chunk = _data.slice(i, i + chunkSize);
        result.push({ type: "features", data: chunk, product: obj });
      }
    }

    return result;
  });
};

export const prepareProductVirtualizeItem = (
  dataProducts: any,
  sectionCategory: any = null,
  bannersCategory: any = null
) => {
  const rows = [
    {
      type: "category",
      data: sectionCategory,
    },
    {
      type: "banner",
      data: bannersCategory,
    },
  ];

  const productRows = _.sortBy(dataProducts || [], ["position"])
    .map((item: any) => {
      const _items = _.sortBy(item.products.docs, ["position"]);
      return transformData(_items);
    })
    .flat();

  return rows.concat(productRows);
};

export const slugify = (str: string, char = "-") => {
  return str
    .toLowerCase()
    .normalize("NFD") // Chuyển Unicode sang dạng tổ hợp (NFD)
    .replace(/[\u0300-\u036f]/g, "") // Loại bỏ dấu (accents)
    .replace(/đ/g, "d") // Chuyển "đ" -> "d"
    .replace(/[^a-z0-9\s-]/g, "") // Loại bỏ ký tự đặc biệt
    .replace(/\s+/g, char) // Thay thế khoảng trắng bằng dấu gạch ngang
    .replace(new RegExp(`${char}+`, "g"), char); // Rút gọn dấu gạch ngang liên tiếp
};
